import { createContext, useContext, useState, useEffect, useCallback } from 'react'

const ThemeContext = createContext()

const THEMES = {
  ghibli: 'ghibli',
  corporate: 'corporate'
}

const COLOR_MODES = {
  dark: 'dark',
  light: 'light'
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('tdo-theme') || THEMES.ghibli
  })
  const [colorMode, setColorMode] = useState(() => {
    return localStorage.getItem('tdo-color-mode') || COLOR_MODES.dark
  })

  const toggleColorMode = useCallback(() => {
    setColorMode(prev => prev === COLOR_MODES.dark ? COLOR_MODES.light : COLOR_MODES.dark)
  }, [])

  useEffect(() => {
    localStorage.setItem('tdo-theme', theme)
    localStorage.setItem('tdo-color-mode', colorMode)

    document.body.classList.remove('theme-corporate', 'light')
    if (theme === THEMES.corporate) {
      document.body.classList.add('theme-corporate')
    }
    if (colorMode === COLOR_MODES.light) {
      document.body.classList.add('light')
    }
  }, [theme, colorMode])

  const value = {
    theme,
    setTheme,
    themes: THEMES,
    colorMode,
    setColorMode,
    toggleColorMode,
    colorModes: COLOR_MODES
  }

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useTheme() {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }
  return context
}
